import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';

import { CompanyRegistrationRequestModel, CompanyRegistrationResponseModel } from '../../model';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  constructor(private readonly http: HttpClient) {}

  /**
   * Public company registration for advisors. Hit before login — no Keycloak token exists,
   * so the AuthInterceptor skips adding an Authorization header for the registration routes.
   */
  public register(payload: CompanyRegistrationRequestModel): Observable<CompanyRegistrationResponseModel> {
    return this.http.post<CompanyRegistrationResponseModel>(
      `${environment.apiEndpoint}/account/company/registration`,
      payload,
    );
  }
}
